/**
 * Toast messages and options shown when retrieval completes.
 * Used by RetrievalProgressRefreshManager and RetrievalProgressInitialManager.
 */

export const RETRIEVAL_TOAST_INITIAL = 'Your org is ready. Try a refactor or run a security scan.';
export const RETRIEVAL_TOAST_FULL_REFRESH = 'Up to date with Salesforce.';
export const retrievalToastMetadataType = (metadataType: string) =>
  `${metadataType} is up to date with Salesforce.`;

export const RETRIEVAL_COMPLETE_TOAST_OPTIONS = {
  position: 'top-center' as const,
  duration: 5000,
};

/**
 * Deep primary (same hue as --primary, lower lightness). No shadow.
 * Use with RetrievalCompleteToast component for visible close button.
 */
export const RETRIEVAL_COMPLETE_TOAST_STYLE = {
  background: 'hsl(214 85% 32%)',
  color: 'hsl(var(--primary-foreground))',
  border: 'none',
  padding: '12px 16px',
  borderRadius: '10px',
  fontSize: '13px',
  fontWeight: 500,
  maxWidth: '420px',
};
